import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * 画像情報を表示するクラス
 *
 * @export ImageInfoRendererComponent
 * @class ImageInfoRendererComponent
 */
@Component({
  selector: 'app-image-info-renderer1407',
  templateUrl: 'image-info-renderer.component.html',
})
export class ImageInfoRendererComponent implements OnChanges {
  @Input() data: any;

  /**
   * 連携された値が変更された際に、メソッドを呼び出す
   *
   * @param {SimpleChanges} changes 変更イベント
   *
   * @memberof ImageInfoRendererComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'data':
          this.data = changes.data.currentValue;
          break;
      }
    });
  }
}
